<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-07-02 09:26:02
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardMap.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="card">
    <div class="card-title flex items-center content-space-between">
      <div class="card-title--left">
        <i class="el-icon-school"></i> 招生招聘
      </div>

      <!-- <div class="card-title--right" @click="handleGoListClick">更多></div> -->
    </div>

    <div class="" style="margin: 20px 0 0; flex-wrap: wrap">
      <div>
        <div id="container" style="height: 210px"></div>
      </div>
      <div style="margin: 0 6px">
        <div>{{ params.addr }}</div>

        <div>{{ params.phone_one }}</div>

        <div>{{ params.phone_two }}</div>

        <div>
          <el-image
            v-if="params.image_one"
            style="width: 120px; height: 120px; margin-right: 20px"
            :src="params.image_one"
            fit="fit"
          ></el-image>

          <el-image
            v-if="params.image_two"
            style="width: 120px; height: 120px"
            :src="params.image_two"
            fit="fit"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  props: {
    params: {
      type: Object,
    },
  },

  watch: {
    params: {
      deep: true,
      immediate: true, // （可选）立即触发一次
      handler() {
        const lng = parseFloat(this.params.map_lng);
        const lat = parseFloat(this.params.map_lat);

        if (isNaN(lng) || isNaN(lat)) {
          console.error("地图经纬度无效", this.params);
          return;
        }

        this.center = [lng, lat];
        this.initAMap();
      },
    },
  },

  data() {
    return {
      center: [116.397428, 39.90923],
      map: null,
      marker: null,
    };
  },

  mounted() {
    const lng = parseFloat(this.params.map_lng);
    const lat = parseFloat(this.params.map_lat);

    if (isNaN(lng) || isNaN(lat)) {
      console.error("地图经纬度无效", this.params);
      return;
    }

    this.center = [lng, lat];
    this.initAMap();
  },

  methods: {
    initAMap() {
      try {
        window._AMapSecurityConfig = {
          securityJsCode: "8a03991efbfe09648b702babc8ac01dc",
        };
        AMapLoader.load({
          key: "e492e1e0a7e823de130ab758977ce158",
          version: "2.0",
        })
          .then((AMap) => {
            this.map = new AMap.Map("container", {
              viewMode: "2D",
              zoom: 15,
              center: this.center,
            });

            this.marker = new AMap.Marker({ map: this.map, draggable: true });

            this.marker.setPosition(this.center);

            this.map.on("click", () => {
              this.handleGoMap();
            });
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (err) {
        console.error("高德地图加载失败", err);
      }
    },

    handleGoMap() {
      const { map_lng, map_lat, addr } = this.params;
      if (!map_lng || !map_lat) {
        this.$message.warning("暂未配置地图坐标");
        return;
      }
      const url = `https://uri.amap.com/marker?position=${map_lng},${map_lat}&name=${encodeURIComponent(
        addr,
      )}&src=webapp&coordinate=gaode`;
      window.open(url, "_blank");
    },

    handleGoListClick() {},
  },
};
</script>

<style lang="scss" scoped>
.card {
  // height: 470px;
  color: #565656;
  font-size: 16px;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  padding: 14px 0;
}

.card-title--right {
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  padding: 14px 0;
  cursor: pointer;
}

.card-image {
  display: block;
  width: 100%;
  height: 324px;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  // min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}
</style>
